import { render, staticRenderFns } from "./CoursewareStructuralElementDialogAddChooser.vue?vue&type=template&id=49d6201c&scoped=true&"
import script from "./CoursewareStructuralElementDialogAddChooser.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementDialogAddChooser.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareStructuralElementDialogAddChooser.vue?vue&type=style&index=0&id=49d6201c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d6201c",
  null
  
)

export default component.exports